import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Timestampable, Untrackable } from '../../abstract/Document';
import { type Wedding, Weddings } from '../Weddings';
import type { IWeddingSubscription } from './Subscriptions.types';
import type { PartialWithFieldValue } from 'firebase/firestore';

@Timestampable
@Untrackable
export class Subscription extends AbstractDocument<IWeddingSubscription> {
  readonly collections = {};
}

export class Subscriptions extends AbstractCollection<Subscription, IWeddingSubscription> {
  static path = 'subscriptions';

  constructor(document: Wedding) {
    super(document.collection(Subscriptions.path), Subscription);
  }

  /**
   * Get subscription with ID 'premium'.
   */
  async getPremium() {
    return this.getById('premium').get();
  }

  /**
   * Set subscription with ID 'premium'.
   */
  async setPremium(premium: PartialWithFieldValue<IWeddingSubscription>) {
    return this.getById('premium').update(premium);
  }

  get wedding() {
    return Weddings._.getById(this.reference.parent!.id);
  }
}
